import * as React from "react";
import { Component, Fragment } from "react";

import { connect } from "react-redux";
import { IRootState } from "../../../store";
import DispatchProps from "../../../utils/DispatchProps";
import ApiService from "../../ApiService";
import Actions from "../../../redux/Actions";

import { History } from "history";
import OnboardTimeline, {OnboardTimelineItem} from "./OnboardTimeline";
import OnboardHelpBox from "./OnboardHelpBox";
import School from "../../../models/School";
import OnboardNavigation from "./OnboardNavigation";
import { SchoolTheme } from "./SchoolTheme";
import { SchoolThemeCard } from "./SchoolThemeCard";
import { SchoolLogoCard } from "./SchoolLogoCard";
import { MessageBarType } from "office-ui-fabric-react/lib-commonjs";
import LoadingPage from "../../LoadingPage";

interface OnboardSchoolThemePageProps {
    tenantId: string;
    schoolCode: string;


    apiService: ApiService;
    history: History;
}

interface OnboardSchoolThemePageState {
    school?: School;
    updatedSchoolTheme?: SchoolTheme;
    updatedSchoolLogo?: File;
    schoolLogoSet: boolean;
    currentLogo?: File;
}

class OnboardSchoolThemePage extends Component<OnboardSchoolThemePageProps & DispatchProps, OnboardSchoolThemePageState> {

    constructor(props: OnboardSchoolThemePageProps & DispatchProps) {
        super(props);
        this.state = {
            updatedSchoolTheme: undefined,
            updatedSchoolLogo: undefined,
            schoolLogoSet: false,
            currentLogo: undefined
        };

    }

    async componentDidMount(): Promise<void> {
        if (this.props.tenantId) {
            await this.load();
        }

        const theme = await this.props.apiService.getSchoolTheme(this.props.tenantId, this.props.schoolCode);
        const image = await this.props.apiService.getSchoolLogo(this.props.tenantId, this.props.schoolCode);

        this.setState({
            updatedSchoolTheme: theme,
            currentLogo: image,
            schoolLogoSet: image == undefined ? false : true
        });

    }

    async componentDidUpdate(prevProps: Readonly<OnboardSchoolThemePageProps & DispatchProps>, prevState: any): Promise<void> {
        if (this.props.tenantId !== prevProps.tenantId || this.props.schoolCode !== prevProps.schoolCode) {
            await this.load();
        }

        if (this.state.updatedSchoolTheme !== prevState.updatedSchoolTheme) {
            console.log("this.state.updatedSchoolTheme : ");
            console.log(this.state.updatedSchoolTheme);
        }

        if (this.state.updatedSchoolLogo !== prevState.updatedSchoolLogo) {
            console.log("this.state.updatedSchoolLogo : ");
            console.log(this.state.updatedSchoolLogo);
        }
    }

    private async load(): Promise<void> {
        var school = await this.props.apiService.getSchool(this.props.tenantId, this.props.schoolCode)

        this.setState({
            school
        });
    }

    private async saveLogo(): Promise<boolean> {
        try {
            if (this.props.tenantId != null && this.props.schoolCode != null && this.state.updatedSchoolLogo != null) {
                await this.props.apiService.putSchoolLogo(this.props.tenantId, this.props.schoolCode, this.state.updatedSchoolLogo);

                this.props.dispatch(Actions.showMessageBar(`Saved School Logo`, MessageBarType.success));

                return true;
            }

            if (this.state.updatedSchoolLogo == null && this.state.schoolLogoSet) {
                //They already had a logo set
                return true;
            } else {
                return false;
            }
        }
        catch (e) {
            this.props.dispatch(Actions.showMessageBar(`Failed to save School Logo : ${e.message}`, MessageBarType.error));
            return false;
        }
    }

    private async saveTheme(): Promise<boolean> {
        if (!this.state.updatedSchoolTheme) {
            return false;
        }

        try {
            await this.props.apiService.putSchoolTheme(this.props.tenantId, this.props.schoolCode, this.state.updatedSchoolTheme);

            this.props.dispatch(Actions.showMessageBar(`Saved School Theme`, MessageBarType.success));

            return true;
        }
        catch (e) {
            this.props.dispatch(Actions.showMessageBar(`Failed to save School Theme : ${e.message}`, MessageBarType.error));
            return false;
        }
    }

    private save = async (): Promise<boolean> => {
        var savedLogo = await this.saveLogo();
        var savedTheme = await this.saveTheme();

        return savedLogo && savedTheme;
    }

    private onSchoolThemeChanged = (updatedSchoolTheme: SchoolTheme): void => {
        this.setState({
            updatedSchoolTheme: updatedSchoolTheme
        });
    }

    private onSchoolLogoChanged = (updatedSchoolLogo: File | undefined, logoSet: boolean): void => {
        this.setState({
            updatedSchoolLogo: updatedSchoolLogo,
            schoolLogoSet: logoSet
        });
    }

    public render(): JSX.Element {
        if (this.state.school === undefined) {
            return <LoadingPage />;
        }

        const schoolLogoCard = this.state.school
            ? <SchoolLogoCard
                  onSchoolLogoChanged={this.onSchoolLogoChanged}
                  school={this.state.school}
                  currentLogo={this.state.currentLogo}
                  megaMenuBgColour={this.state.updatedSchoolTheme?.megaMenuBgColour}
                  megaMenuFontColour={this.state.updatedSchoolTheme?.megaMenuFontColour}/>
            : null;

        const schoolThemeCard = this.state.updatedSchoolTheme && this.state.school
            ? <SchoolThemeCard
                  schoolTheme={this.state.updatedSchoolTheme}
                  onSchoolThemeChanged={this.onSchoolThemeChanged}
                  school={this.state.school}/>
            : null;

        return (
            <Fragment>
                <OnboardHelpBox currentTimelineItemKey={"school-theme"}/>
                <OnboardTimeline tenantId={this.props.tenantId} schoolCode={this.props.schoolCode} apiService={this.props.apiService}>
                    {(school: School,timelineItems: OnboardTimelineItem[]) => {
                        return (
                            <Fragment>
                                <div className={"flex-item--flex-1"}>
                                    {schoolLogoCard}
                                </div>
                                <div className={"flex-item--flex-1"}>
                                    {schoolThemeCard}
                                </div>
                                <OnboardNavigation currentTimelineItemKey={"school-theme"}  timelineItems={timelineItems} completeItem={this.save}
                                                   enableNext={true} enableSave={false} history={this.props.history}
                                                   tenantId={this.props.tenantId} schoolCode={this.props.schoolCode}/>
                            </Fragment>
                        );
                    }}
                </OnboardTimeline>
            </Fragment>
        );
    }
}

export default connect(
    (state: IRootState, ownProps: any): OnboardSchoolThemePageProps => {
        return {
            tenantId: ownProps.match.params.tenantId,
            schoolCode: ownProps.match.params.schoolCode,

            apiService: state.auth.apiService,
            history: ownProps.history
        };
    }
)(OnboardSchoolThemePage)